
import { AxiosResponse } from "axios";
import NgongVegBanner from "@/components/NgongVegBanner";
import { computed, defineComponent, onMounted, ref } from "vue";
import http from "../../../../../common/services/http";
import { format } from "date-fns";

export default defineComponent({
  name: "Margins",
  components: { NgongVegBanner },
  setup() {
    const processing = ref(false);
    const downloadLoading = ref(false);

    const customers = ref([]);
    const user_id = ref(0);
    const customer = computed((): any => {
      return customers.value?.find((c: any) => c.id == user_id.value);
    });

    const margins = ref({});

    function fetchCustomers() {
      processing.value = true;
      http.get(`/api/users?role=customer&active=1&fetch=all`).then(res => {
        customers.value = res.data;
        processing.value = false;
      });
    }

    function fetchMargins(id: any) {
      processing.value = true;

      http.get(`/api/margins?customer=${id}`).then(res => {
        margins.value = res.data;
        processing.value = false;
      });
    }

    function addCommas(value: number) {
      if (value !== undefined) {
        const value2dp = value.toFixed(2);
        return value2dp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }

    function downloadReport(response: AxiosResponse<any>, reportName?: any) {
      const fileUrl = window.URL.createObjectURL(response.data);
      const fileLink = document.createElement("a");
      const date = format(new Date(), "yyyy-MM-dd");

      fileLink.href = fileUrl;
      fileLink.setAttribute(
        "download",
        reportName + date + ".xlsx",
      );
      document.body.appendChild(fileLink);

      fileLink.click();

      downloadLoading.value = false;
    }

    function fetchMarginsExport(id?: any) {
      downloadLoading.value = true;
      if (id) {
        let name;
        name = customer.value?.name
        http
          .get(
            `/api/margins-by-customer-report?customer=${id}&start=${fD(
              reportDates.value.start, "yyy-MM-dd"
            )}&end=${fD(reportDates.value.end, "yyyy-MM-dd")}`,
            {
              responseType: "blob"
            }
          ).then(response => {
            downloadReport(response, customer.value?.name + " Margins Report ")
          })
      } else {
        http
          .get(
            `/api/margins-by-customer-report?start=${fD(
              reportDates.value.start, "yyy-MM-dd"
            )}&end=${fD(reportDates.value.end, "yyyy-MM-dd")}`,
            {
              responseType: "blob"
            }
          ).then(response => {
            downloadReport(response, "Customer Margins Report ")
          })
      }
    }

    function fetchProfitabilityExport() {
      downloadLoading.value = true;
      http
        .get(
          `/api/customer-profitability-report?start=${fD(
            reportDates.value.start, "yyy-MM-dd"
          )}&end=${fD(reportDates.value.end, "yyyy-MM-dd")}`,
          {
            responseType: "blob"
          }
        ).then(response => {
          downloadReport(
            response,
            "Customer Profitability Report (" + fD(
              reportDates.value.start, "yyy-MM-dd"
            ) + " to " + fD(reportDates.value.end, "yyyy-MM-dd") + ") "
          )
        })
    }

    function friday() {
      const date = new Date();
      const last = new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000);

      return date.getDay() < 5
        ? new Date(last.setDate(last.getDate() - (last.getDay() - 1) + 4))
        : new Date(date.setDate(date.getDate() - (date.getDay() - 1) + 4));
    }

    const start = ref(friday());
    const end = computed(
      () => new Date(new Date(start.value).getTime() + 6 * 24 * 60 * 60 * 1000)
    );

    function fD(d: any, f = "PPPP") {
      return format(d, f);
    }

    const reportDates = ref({
      start: friday(),
      end: new Date(new Date(friday()).getTime() + 6 * 24 * 60 * 60 * 1000),
    })

    onMounted(() => {
      fetchCustomers();
    });

    return {
      user_id,
      customer,
      customers,
      fetchMargins,
      margins,
      processing,
      addCommas,
      downloadLoading,
      fetchMarginsExport,
      // start,
      // end,
      fD,
      fetchProfitabilityExport,
      reportDates,
    };
  }
});
